export default __webpack_public_path__ + "media/images/mailer/logo-cebd1f7654a6f64405dff7bd6ec4e9f3.png";